// TO DO: Extract to theme (WP-254).
// These values should not be used and only exist to add a compatibility layer for legacy code.
const HEX = {
    purple: "#fe1251",
    brightPurple: "#fe1247",
    blue: "#3d02ff",
    white: "#fff",
    preWhite: "#f6f6f7",
    lightGrey: "#dcdcdc",
    grey: "#969696",
    darkGrey: "#333333",
    black: "#000"
};
const RGB = {
    blue: "61, 2, 255",
    white: "255, 255, 255",
    darkGrey: "51, 51, 51",
    purple: "254, 18, 81",
    brightPurple: "254, 18, 71"
};

export { HEX, RGB };
